/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Listening_LogoInputs */

const en_nav_app_listening_logo = /** @type {(inputs: Nav_App_Listening_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening logo`)
};

const es_nav_app_listening_logo = /** @type {(inputs: Nav_App_Listening_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de Listening`)
};

/**
* | output |
* | --- |
* | "Listening logo" |
*
* @param {Nav_App_Listening_LogoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_listening_logo = /** @type {((inputs?: Nav_App_Listening_LogoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Listening_LogoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_listening_logo(inputs)
	return en_nav_app_listening_logo(inputs)
});